import http, { expandURI } from '@/utils/ajax'
import { TOTALSR_INIT_LOADING, TOTALSR_INIT_SUCCESS, TOTALSR_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'

const state = {
  totalSalesRevenue: {
    init: 0,
    menu: {},
    revenue: null,
    lastUpdated: null,
    scope: null,
    info: null,
    appIds: []
  }
}

const getters = {

}

const actions = {
  async initTotalSalesRevenue({ commit, state }, data) {
    commit(TOTALSR_INIT_LOADING)
    const apiUrl = state.permitWidgets.totalSalesRevenue
    if (apiUrl) {
      try {
        let params = {
          from: formatDisplayDateTime2(data.from),
          to: formatDisplayDateTime2(data.to)
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)
        Object.assign(data, {
          menu: menu,
          revenue: result.data.revenue,
          info: result.data.info,
          appIds: result.data.appIds
        })
        commit(TOTALSR_INIT_SUCCESS, data)
      } catch (error) {
        commit(TOTALSR_INIT_FAIL)
      }
    } else {
      commit(TOTALSR_INIT_FAIL)
    }
  }
}

const mutations = {
  [TOTALSR_INIT_LOADING](state) {
    state.totalSalesRevenue.init = 0
  },
  [TOTALSR_INIT_SUCCESS](state, data) {
    const { totalSalesRevenue } = state
    totalSalesRevenue.menu = data.menu
    totalSalesRevenue.init = 1
    totalSalesRevenue.lastUpdated = new Date()
    totalSalesRevenue.scope = data.scope
    totalSalesRevenue.revenue = data.revenue
    totalSalesRevenue.info = data.info
    totalSalesRevenue.appIds = data.appIds
  },
  [TOTALSR_INIT_FAIL](state) {
    state.totalSalesRevenue.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
